"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));
/**
 * This component prevents pointer events from being triggered on its children.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/AbsorbPointer-class.html
 */


const AbsorbPointer = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  pointer-events: ", ";\n"])), ({
  absorbing = true
}) => absorbing ? 'none' : 'initial');
exports.default = AbsorbPointer;